
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'recoHas',
  data() {
    return {
      recoHas: 'https://doc.360medics.com/assets/media/cngof/Reco_HAS.pdf',
      recoHasSmall: 'https://www.has-sante.fr/jcms/c_2806160/fr/evaluation-de-la-recherche-des-papillomavirus-humains-hpv-en-depistage-primaire-des-lesions-precancereuses-et-cancereuses-du-col-de-l-uterus-et-de-la-place-du-double-immuno-marquage-p16/ki67',
    };
  },
  methods: {
    isMobile() {
      let resp = false;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        resp = true;
      }
      return resp;
    },
  },
});

